module.exports = __webpack_public_path__ + "static/media/save.d8fa4fb9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/save.svg
// module id = 495
// module chunks = 0